import React from 'react';
import CustomButton from './CustomButton';
import { Flex } from 'antd';

interface CommanFooterProps {
  handleCancel: () => void;
  onSave?: () => void;
  text?: string;
  /** Show only Cancel. */
  hidePrimary?: boolean;
  /** Draw Cancel as the plain 16px text button of a full-panel screen, with or without the primary. */
  plainCancel?: boolean;
}

const CommanFooter: React.FC<CommanFooterProps> = ({
  text,
  handleCancel,
  onSave,
  hidePrimary = false,
  plainCancel = false,
}) => {
  const plain = plainCancel;
  return (
    <>
      <Flex vertical gap={8}>
        {!hidePrimary && (
          <CustomButton
            text={text}
            bgColor='#000'
            color='#fff'
            fontSize='14px'
            fontWeight='600'
            height={'48px'}
            borderRadius='8px'
            padding='0 32px'
            boxShadow={plain ? 'none' : undefined}
            onClick={onSave}
          />
        )}
        <CustomButton
          text={'Cancel'}
          bgColor='transparent'
          color='var(--text-primary)'
          fontSize={plain ? '16px' : '14px'}
          fontWeight={plain ? '400' : '600'}
          lineHeight={plain ? '24px' : undefined}
          boxShadow='none'
          height={plain ? '52px' : '36px'}
          borderRadius={plain ? '8px' : undefined}
          onClick={() => handleCancel()}
        />
      </Flex>
    </>
  );
};

export default CommanFooter;
